"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MTGFuturesAppRequestProcessor = void 0;
const trade_utils_lib_1 = require("trade_utils_lib");
const TradeAPILib_1 = require("TradeAPILib");
const rxjs_1 = require("rxjs");
const MTGFuturesAppRequestProcessor = (params) => {
    var _a, _b;
    const { checkResult } = params;
    if (!checkResult) {
        return (0, rxjs_1.throwError)(() => {
            return { code: -1, message: "Local: Check result is not found" };
        });
    }
    let price_scale = "";
    if (params.priceScaleMode === TradeAPILib_1.MartingalePriceScaleType.percentage) {
        const priceScale = new trade_utils_lib_1.SafeDecimal(params.priceScale).div(100);
        price_scale = priceScale.toString();
    }
    else {
        price_scale = params.priceScale;
    }
    const takeProfitRatioD = new trade_utils_lib_1.SafeDecimal(params.takeProfitRatio).div(100);
    const portfolio = {
        base: params.symbol.base,
        open_price: params.currentPrice,
        price_scale_type: params.priceScaleMode,
        price_scale_param: price_scale,
        take_profit_ratio: takeProfitRatioD.toString(),
        safety_orders: new trade_utils_lib_1.SafeDecimal(params.safetyOrders).toNumber(),
        volume_scale: params.volume_scale,
        condition: params.condition,
        condition_direction: params.condition_direction ? Number(params.condition_direction) : undefined,
        stop_scaling_price: params === null || params === void 0 ? void 0 : params.stopScalingPrice,
        stop_scaling_price_bottom: params === null || params === void 0 ? void 0 : params.stopScalingPriceBottom,
    };
    if (params === null || params === void 0 ? void 0 : params.signal) {
        portfolio.signal_type = (_a = params === null || params === void 0 ? void 0 : params.signal) === null || _a === void 0 ? void 0 : _a.type;
        try {
            portfolio.signal_param = params.signal.type === "immediately" ? "" : JSON.stringify((_b = params.signal) === null || _b === void 0 ? void 0 : _b.param);
        }
        catch (_c) {
            return (0, rxjs_1.throwError)(() => {
                return { code: -1, message: "Local: JSON.stringify(params.signal?.param) error" };
            });
        }
    }
    if (!checkResult.estimateInvestment) {
        return (0, rxjs_1.throwError)(() => {
            return { code: -1, message: "Local: CheckResult no estimateInvestment." };
        });
    }
    const request = {
        sub_order_type: params.sub_order_type,
        type: params.orderType,
        trend: params.trend,
        leverage: params.leverage,
        extra_margin: checkResult.estimateExtraMargin || "0",
        quote: params.symbol.quote,
        quote_investment: checkResult.estimateInvestment,
        portfolio: [portfolio],
        profit_stop_type: TradeAPILib_1.GridStopType.profit_ratio,
        profit_stop: params.takeProfitForBot,
        loss_stop_type: TradeAPILib_1.GridStopType.profit_ratio,
        loss_stop: params.stopLossForBot,
    };
    return (0, rxjs_1.of)(request);
};
exports.MTGFuturesAppRequestProcessor = MTGFuturesAppRequestProcessor;
